import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import FruitsZakatTable from "./FruitsZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Fruits_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Calcul de Zakat sur les fruits - Calculatrice du seuil de Zakat sur les fruits ";
const DESCRIPTION =
  "Calcul de Zakat sur les fruits - Calculatrice du seuil de Zakat sur les fruits pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "calcul de zakat sur les fruits du seuil de zakat sur les fruits, calculatrice calcul de zakat sur les fruits du seuil de zakat sur les fruits, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/fruits-zakat/";
const apiEndpoint = `${SERVER_URL}/${Fruits_Zakat_EndPoint}`;
function FruitsZakatCalculator() {
  const [pricePerKg, setPricePerKgSilver] = useState(0);
  const [weight, setWeight] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [wateringMethod, setWateringMetohd] = useState("");
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleWateringMethodChange = (event) => {
    setWateringMetohd(event.target.value);
  };
  const handlePricePerKgChange = (event) => {
    setPricePerKgSilver(event.target.value);
  };
  const calculateFruitsZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, pricePerKg, wateringMethod }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Calculez la zakat sur les fruits</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                La calculatrice zakat sur les fruits est un outil utilisé pour calculer le montant de la zakat due sur les fruits selon les règles religieuses en Islam. Cette calculatrice calcule le montant financier qui doit être payé comme zakat sur les fruits récolté, et elle comprend tous les types de fruits. De plus, vous pouvez également utiliser la calculatrice zakat sur les dattes pour calculer le montant de la zakat due sur les dattes en fonction de la quantité et de la valeur financière des dattes récolté. Vous pouvez utiliser ces outils pour assurer que votre zakat est payée correctement et en conformité avec les enseignements religieux.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Zakat sur les fruits
                </div>
                <hr />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Poids total des fruits et cultures {" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label
                      htmlFor="pricePerKgNumber"
                      className="form-label ms-2"
                    >
                      Prix par kilogramme {" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="pricePerKgNumber"
                    value={pricePerKg}
                    onChange={handlePricePerKgChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="method" className="form-label ms-2">
                      Méthode d'irrigation utilisée
                    </label>
                  </b>
                  <select
                    id="method"
                    className="form-select"
                    value={wateringMethod}
                    onChange={handleWateringMethodChange}
                  >
                    <option value="">-- Choisissez l'activité --</option>
                    <option value="no-cost">Sans coût</option>
                    <option value="mid-cost">Coût moyen</option>
                    <option value="full-cost">Coût complet</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateFruitsZakat}
                       >
                    Calculer
                    </button>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Erreur :</u>
                    </b>{" "}
                    Veuillez remplir tous les champs correctement.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Résultats:{" "}
                      </div>
                    </h4>
                    <hr />
                    <FruitsZakatTable result={result}></FruitsZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Description de la calculatrice Zakat sur les fruits et cultures
              </div>
              <div className="info-section-body">
                <u>
                  <b> Calculatrice Zakat sur les fruits </b>{" "}
                </u>{" "}
                <br/>
                La calculatrice prend trois paramètres:
                <ul>
                  <li>Poids des fruits (en kilogrammes)</li>
                  <li>Prix par kilogramme de fruits</li>
                  <li>Méthode d'irrigation</li>
                </ul>
                La calculatrice calcule la zakat sur les fruits selon les facteurs suivants:
                <ul>
                  <li>Si la méthode d'irrigation est sans coût, le taux de zakat est de 10%</li>
                  <li>
                    Si la méthode d'irrigation à coût complet, le taux de zakat est de 5%
                  </li>
                  <li>
                    Si la méthode d'irrigation à coût moyen, le taux de zakat est de 7,5%
                  </li>
                </ul>
                Ensuite, le montant de la zakat sur les fruits est calculé en kilogrammes et en valeur financière selon le poids, le taux de zakat et le prix par kilogramme de fruits. Le seuil minimum de zakat sur les fruits est déterminé à 635 kilogrammes.
                <br/>
                La calculatrice renvoie le résultat dans un objet contenant les informations suivantes:
                <ul>
                  <li>Valeur de la zakat sur les fruits en kilogrammes.</li>
                  <li>Valeur financière de la zakat sur les fruits.</li>
                  <li>Seuil minimum de zakat sur les fruits.</li>
                </ul>
                <br />
                <hr />
                <b>Dernière révision : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FruitsZakatCalculator;
